import { TextField, Typography } from "@mui/material";
import { FormData } from "@types";

export const RevisionSummary = ({
  disabled = false,
  formData,
  setFormData,
}: {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  disabled?: boolean;
}) => (
  <div className="flex flex-col">
    <Typography variant="subtitle1" fontWeight="bold">
      Revision Summary
    </Typography>
    {!disabled && (
      <Typography variant="subtitle2">
        Please define the changes in this revision. If it is the initial
        release, state so. Revision histories will be available during audits so
        provide sufficient detail.
      </Typography>
    )}
    <TextField
      hiddenLabel
      className="pt-2"
      disabled={disabled}
      fullWidth
      minRows={3}
      multiline
      value={formData.revisionSummary}
      onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setFormData((prev) => ({
          ...prev,
          revisionSummary: event.target.value,
        }));
      }}
      sx={{
        "& .Mui-disabled:before": {
          borderBottomStyle: "none",
        },
        "&.MuiInputBase-root-MuiFilledInput-root.Mui-disabled:before": {
          borderBottomStyle: "none",
        },
        "& .MuiFilledInput-root.Mui-disabled:before": {
          borderBottomStyle: "none",
        },
        "& .MuiFilledInput-root.Mui-disabled:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.12)",
          pointerEvents: "none",
        },
      }}
    />
  </div>
);

export default RevisionSummary;
